import React, {useMemo} from "react";
import {FormattedMessage, useIntl} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import {navFeatureCLick} from "../../../look/lookNavigation/lookFunctions";
import {FeatureGroup} from "../../../../interfaces/FeatureGroup";
import {Feature} from "../../../../interfaces/Feature";
import {useAppDispatch, useAppSelector} from "../../../../storeHooks";
import {updateCanvasCount} from "../../../../actions/actionFunctions";

interface BodyPanelShowerWallFullWallCheckboxProps {
  featureGroup: FeatureGroup & {
    isFullWall: (f?: Feature) => boolean;
  };
  showColumnCheckbox: boolean;
}

export default function BodyPanelShowerWallFullWallCheckbox({
                                                              featureGroup,
                                                              showColumnCheckbox,
                                                            }: BodyPanelShowerWallFullWallCheckboxProps) {

  const intl = useIntl();

  const canvasCount = useAppSelector(state => state.bathroomVisualizerState.canvasCount);

  const dispatch = useAppDispatch();

  const hideComponent = !featureGroup || !featureGroup.isFullWall || !featureGroup.activeFeature
    || !featureGroup.getParent || !featureGroup.getParent().layout || (featureGroup.getParent().layout.type !== 11)
    || featureGroup.partId !== "shower_wall";

  const sameFeatureWithOppositeWall = useMemo(() => {
    if (hideComponent) {
      return null;
    }
    const name1 = featureGroup.activeFeature.getSplittedFeatureName();
    const conditions = featureGroup.getArrayOfConditions();
    const currentWallIsFullWall = featureGroup.isFullWall();
    return featureGroup.features.find(f => {
      return (f.getSplittedFeatureName() === name1) && f.matchesMetaForArrayOfConditions(conditions)
        && (f.dbFeature.id !== featureGroup.activeFeature.dbFeature.id)
        && (currentWallIsFullWall ? !featureGroup.isFullWall(f) : featureGroup.isFullWall(f))
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup, hideComponent, canvasCount]);

  if (hideComponent) {
    return null;
  }

  const checkboxClick = () => {

    console.log(featureGroup);
    // console.log("currentColorFeatures", currentColorFeatures);
    // console.log("sameColorFeatures", sameColorFeatures);
    if (!sameFeatureWithOppositeWall) {
      return null
    }

    // Analytics.sendClickEvent(analyticsLabel + !groheSameColorCheckboxApplied);

    featureGroup.activeFeature = sameFeatureWithOppositeWall; // first we need to set it, so it will not be replaced it handleClick
    navFeatureCLick(sameFeatureWithOppositeWall); // switch between full wall and normal wall
    dispatch(updateCanvasCount());
  }

  const checked = !!featureGroup.isFullWall();

  if (showColumnCheckbox) {
    return (
      <div className="ui-radio-block">
        <span className="ui-radio-label nowrap"><FormattedMessage id={"desktop.nav.fullWall"}/>:</span>
        <button className={"ui-radio ui-radio--small" + (checked ? " ui-radio--checked" : "")}
                onClick={checkboxClick}>
          <span className="ui-radio-circle"/>
          <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
          <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
        </button>
      </div>
    )
  }

  return (
    <FormControlLabel
      control={
        <Switch
          className="gm-ios-checkbox"
          disabled={!sameFeatureWithOppositeWall}
          disableRipple
          checked={checked}
          onChange={checkboxClick}
          color="primary"
        />
      }
      label={intl.formatMessage({id: "desktop.nav.fullWall"})}
    />
  )
}
